module.exports = "<div class=\"row\" (click)=\"toggleAnswer($event)\">\n    <div class=\"questionText col-10 col-md-6\">{{question.display_index}}. {{question.prompt}}</div>\n    <div class=\"col-2 col-md-6\">\n      <input id=\"check-{{question.id}}\" type=\"checkbox\" class=\"form-control col-2\" \n      [checked]=\"isChecked()\" (click)=\"toggleAnswer($event)\" />\n      <label for=\"check-{{question.id}}\"></label>\n    </div>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/assessments/question-single-checkbox/question-single-checkbox.component.html
// module id = ./src/app/assessments/question-single-checkbox/question-single-checkbox.component.html
// module chunks = main